import { render, staticRenderFns } from "./ApprReferLst.vue?vue&type=template&id=3625645d&scoped=true"
import script from "./ApprReferLst.vue?vue&type=script&lang=js"
export * from "./ApprReferLst.vue?vue&type=script&lang=js"
import style0 from "./ApprReferLst.vue?vue&type=style&index=0&id=3625645d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625645d",
  null
  
)

export default component.exports